import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'

const loadPaymentTerms = (params: PaginatedParams): PaginatedResponse<any> => {
  const { page = 1, limit = 100 } = params

  return axios.get('/parameters/payment-terms', {
    params: {
      page,
      limit,
      ...params
    }
  })
}

export function useLoadPaymentTerms(params: PaginatedParams) {
  return useQuery(['paymentTerms', params], () => loadPaymentTerms(params), {
    keepPreviousData: true,
    onError: () =>
      toast.error('Não foi possível carregar as condições de pagamento!', {
        toastId: 'loadPaymentTerms'
      })
  })
}
